module.exports = __webpack_public_path__ + "img/stick_activites_visite_guidee.3edf29be.svg";